export default [
  {
    title: "Get your labs drawn",
    description:
      "After purchasing your comprehensive bloodwork and completing your questionnaire, you will be directed to a lab or to have a phlebotomist come to you. ",
    image: "images/redesign/landing-how-it-works-3.jpeg",
    alt: "Step 1",
  },
  {
    title: "Download the Ways2Well App",
    description:
      "Prepare to get a detailed breakdown of your biomarkers and track your health evolution.",
    image: "images/redesign/landing-how-it-works-2.jpeg",
    alt: "Step 2",
  },
  {
    title: "Receive Your Results",
    description: "View your results in the app within 5-7 business days.",
    image: "images/redesign/landing-how-it-works-3.jpeg",
    alt: "Step 3",
  },
  {
    title: "Get Your Personalized Protocols",
    description:
      "Review your custom health protocols with ALLEN or schedule time with a Ways2Well clinician.",
    image: "images/redesign/landing-how-it-works-4.png",
    alt: "Step 4",
  },
];
